import { CanEnableDomainFnReq, CanEnableDomainFnRes } from '@uploadcam/common';
import { Functions, httpsCallable } from 'firebase/functions';

export class CanEnableDomainInteractor {
  private readonly canEnableDomainFn = httpsCallable<CanEnableDomainFnReq, CanEnableDomainFnRes>(
    this.functions,
    'canEnableDomain',
  );

  constructor(private readonly functions: Functions) {}

  public async execute(): Promise<CanEnableDomainFnRes> {
    const res = await this.canEnableDomainFn();
    return res.data;
  }
}
